/* ==========================================================================
   assets/theme.js — TRU SPOOKY
   Three small things: the mobile nav, the ambient bat flybys, and the
   click-to-poof page transition.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rand = function (min, max) { return Math.random() * (max - min) + min; };
  var pick = function (a) { return a[Math.floor(Math.random() * a.length)]; };

  /* =================================================== 1. mobile nav */
  var burger = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  var navClose = document.querySelector('[data-nav-close]');

  function setNav(open) {
    if (!nav || !burger) return;
    nav.classList.toggle('is-open', open);
    burger.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (burger) burger.addEventListener('click', function () {
    setNav(!nav.classList.contains('is-open'));
  });
  if (navClose) navClose.addEventListener('click', function () { setNav(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setNav(false);
  });

  /* ================================================ 2. ambient bats */
  /* Markup mirrors snippets/bat.liquid — keep the two in sync if you
     redraw the bat. */
  var BAT_SVG =
    '<svg class="bat" viewBox="0 0 64 34" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<g class="bat__wing bat__wing--l"><path d="M32 17C25 6 15 3 4 8c6 2 8 6 6 11 6-3 13-1 18 4z"/></g>' +
    '<g class="bat__wing bat__wing--r"><path d="M32 17c7-11 17-14 28-9-6 2-8 6-6 11-6-3-13-1-18 4z"/></g>' +
    '<path class="bat__body" d="M32 9c3.2 0 5 2.4 5 6.4 0 4.6-1.9 8.8-5 11.6-3.1-2.8-5-7-5-11.6C27 11.4 28.8 9 32 9z"/>' +
    '<path class="bat__ears" d="M28.6 10.4 26.6 4.6l4.6 3.2zM35.4 10.4l2-5.8-4.6 3.2z"/></svg>';

  var batLayer = document.getElementById('ambient-bats');
  var batTimer = null;

  function flyBat() {
    if (!batLayer || document.hidden) return;

    var host = document.createElement('div');
    host.innerHTML = BAT_SVG;
    var bat = host.firstChild;

    var scale = rand(0.35, 0.9);
    var toLeft = Math.random() < 0.5;
    var flip = toLeft ? ' scaleX(-1)' : '';
    var y = rand(0.06, 0.42) * window.innerHeight;
    var drift = rand(-90, 90);
    var duration = rand(9000, 16000);
    var w = 54 * scale;

    bat.style.width = w + 'px';
    bat.style.position = 'absolute';
    bat.style.top = '0';
    bat.style.left = '0';

    var from = toLeft ? window.innerWidth + w : -w * 2;
    var to = toLeft ? -w * 2 : window.innerWidth + w;

    batLayer.appendChild(bat);

    var anim = bat.animate([
      { transform: 'translate3d(' + from + 'px,' + y + 'px,0) scale(' + scale + ')' + flip, opacity: 0 },
      { transform: 'translate3d(' + (from + (to - from) * 0.25) + 'px,' + (y + drift) + 'px,0) scale(' + scale + ')' + flip, opacity: 0.85, offset: 0.25 },
      { transform: 'translate3d(' + (from + (to - from) * 0.6) + 'px,' + (y - drift * 0.7) + 'px,0) scale(' + scale + ')' + flip, opacity: 0.85, offset: 0.6 },
      { transform: 'translate3d(' + to + 'px,' + (y + drift * 0.4) + 'px,0) scale(' + scale + ')' + flip, opacity: 0 }
    ], { duration: duration, easing: 'linear', fill: 'forwards' });

    anim.onfinish = function () { bat.remove(); };
  }

  /* Spawn gap, tuned against the 9–16s flight time above rather than picked at
     random — concurrency is roughly flight-time ÷ gap, so halving this pair
     doubles how many are in the air. 2.5–5s holds around three at a time.
     Widen it to thin the sky out, tighten it to fill it. */
  var BAT_GAP = [2500, 5000];

  function scheduleBat() {
    clearTimeout(batTimer);
    batTimer = setTimeout(function () {
      flyBat();
      scheduleBat();
    }, rand(BAT_GAP[0], BAT_GAP[1]));
  }

  function startBats() {
    if (reduced || !batLayer || !('animate' in Element.prototype)) return;
    // Two staggered launches so the sky is never empty when you first land.
    setTimeout(flyBat, 1200);
    setTimeout(flyBat, 5200);
    scheduleBat();
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) clearTimeout(batTimer);
    else if (!reduced) scheduleBat();
  });

  /* The homepage waits for the intro to land before bats start crossing
     the chrome; other templates start immediately. */
  if (document.querySelector('[data-hero]')) {
    document.addEventListener('truspooky:introdone', startBats, { once: true });
  } else {
    startBats();
  }

  /* ============================================= 3. poof transition */
  var poofLayer = document.getElementById('poof-layer');
  var TONES = ['purple', 'purple', 'orange', 'soot', 'soot'];

  function poofAt(x, y, spread) {
    if (!poofLayer) return;
    var burst = document.createElement('div');
    burst.className = 'poof';
    burst.style.left = x + 'px';
    burst.style.top = y + 'px';

    var count = 16;
    for (var i = 0; i < count; i++) {
      var p = document.createElement('span');
      var angle = (i / count) * Math.PI * 2 + rand(-0.3, 0.3);
      var dist = rand(spread * 0.25, spread * 0.75);
      p.className = 'poof__p puff--' + pick(TONES);
      p.style.setProperty('--s', rand(spread * 0.3, spread * 0.6) + 'px');
      p.style.setProperty('--b', rand(10, 26) + 'px');
      p.style.setProperty('--dx', Math.cos(angle) * dist + 'px');
      p.style.setProperty('--dy', (Math.sin(angle) * dist - spread * 0.28) + 'px');
      p.style.setProperty('--rot', rand(-90, 90) + 'deg');
      p.style.setProperty('--d', rand(700, 1100) + 'ms');
      p.style.setProperty('--o', rand(0.35, 0.75));
      burst.appendChild(p);
    }

    poofLayer.appendChild(burst);
    setTimeout(function () { burst.remove(); }, 1300);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-poof]');
    if (!link) return;
    // Let the browser do its normal thing for new tabs, downloads, modifiers.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    if (link.target === '_blank' || !link.href) return;
    if (reduced) return;

    e.preventDefault();

    var card = link.closest('.pcard') || link;
    var r = card.getBoundingClientRect();
    poofAt(r.left + r.width / 2, r.top + r.height / 2, Math.max(r.width, r.height) * 0.9);

    card.classList.add('is-poofing');
    document.documentElement.classList.add('is-leaving');

    setTimeout(function () { window.location.href = link.href; }, 520);
  });

  /* Coming back via the back button must not land on a faded-out page. */
  window.addEventListener('pageshow', function (e) {
    document.documentElement.classList.remove('is-leaving');
    if (e.persisted) {
      document.querySelectorAll('.is-poofing').forEach(function (el) {
        el.classList.remove('is-poofing');
      });
    }
  });
})();
